import React from "react";
import { useSelector } from "react-redux";
import { AccessibilityPopup } from '@skillz/accessibility';
import { hebrewDateType } from "../../../../enums/hebrewDateType";
import { calendarType as calendarTypeEnum } from '../../../../enums/calendarType';
import CoursePicture from "../../../features/coursePicture/CoursePicture";
import Tag from "../../../features/tag/Tag";
import Calendar from "../../../ui/iconsOld/Calender";
import Men from "../../../ui/iconsOld/Men";
// import LinkIcon from "../../shared/components/ui/icons/Link";
import NavigateLink from "../../../features/navigateLink/navigateLink";
import CopyToCliboard from "../../../ui/buttons/CopyToCliboard";
import FillBGBtn from "../../../ui/buttons/FillBGBtn";
import calendarEdit from "../../../../../assests/calendar/calendarEdit.png"
import bagrutPopup from "../../../../../assests/icons/bagrutPopup.png"
// import Sharp from "../../../../../shared/components/ui/icons/Sharp";
import Text from "../../../features/text/Text";
import useInstance from "../../../../hooks/useInstance";
import useHebrewDate from "../../../../hooks/useHebrewDate ";
import useTextByLangAndGender from "../../../../hooks/useTextByLangAndGender";
import classes from "./CalendarEventPopup.module.css"


const CalendarEventPopup = ({ holiday, Domain, DomainColor, Picture, Id, tags, Subject, Description, ProviderDescription, StartTime, IsAllDay, EndTime, Teachers, Link, hiddenLink, ProviderLogo, calendarType, isAssessment, bagrut }) => {


    const instance = useInstance();
    const hebrewDate = useHebrewDate();
    const { texts } = useSelector(state => state.translate);
    const textByLangAndGender = useTextByLangAndGender()

    return <AccessibilityPopup accessibilityDescription={'title'} close={() => console.log('close')}>
        <div className={`${classes.QuickInfoTemplate} ${classes[calendarType]} ${isAssessment ? classes.Assessment : null} ${holiday ? classes.Holiday : null}`} style={{ borderColor: DomainColor }}>
            <div className={classes.QuickInfoTopPart}>
                <div className={classes.Image}>
                    <CoursePicture picture={isAssessment ? calendarEdit : bagrut ? bagrutPopup : Picture} courseId={Id} />
                </div>
                <div className={classes.Title}>
                    {tags && <div className={classes.Tags}>
                        {tags.map((tag, index) => <Tag key={index} name={tag} dropClass={classes.TagDropClass} />)}
                    </div>}
                    {isAssessment ?
                        <>
                            <div className={classes.Description}>{Description ? Description : <Text>{ProviderDescription}</Text>}</div>
                            <div className={classes.Subject}>{Subject}</div>
                        </> :
                        <>
                            <div className={classes.Subject}>{Subject}</div>
                            <div className={classes.Description}>{Description ? Description : <Text>{ProviderDescription}</Text>}</div>
                        </>}
                </div>
            </div>
            <hr className={classes.Line} />

            <div className={classes.Details}>
                {<div className={classes.Detail}>
                    <Calendar color="#838383" />
                    <span className={classes.D}>
                        {StartTime ?
                            window.config.calendarMode === calendarTypeEnum.jewish ?
                                `${instance.formatDate(new Date(StartTime), { format: 'EE, ' })} ${hebrewDate(new Date(StartTime), hebrewDateType.day)} ${texts.at ?? ""}${hebrewDate(new Date(StartTime), hebrewDateType.month)} ${hebrewDate(new Date(StartTime), hebrewDateType.year)}`
                                :
                                `${instance.formatDate(new Date(StartTime), { format: `dd  ${texts.at ?? ""}MMMM yyyy` })}`
                            : ''}

                        {IsAllDay ?
                            ` (${texts.allDayEvent ?? ""})` :
                            ` (${EndTime && instance.formatDate(new Date(EndTime), { format: 'HH:mm' })} - ${StartTime && instance.formatDate(new Date(StartTime), { format: 'HH:mm' })})`
                        }
                    </span>
                </div>}

                <div className={classes.Detail}>
                    <Men />
                    <span className={classes.D}>{texts.moderator} {Teachers && Teachers.length ? textByLangAndGender(Teachers[0].name) : texts.noModerator}</span>
                    <span className={classes.D}></span>
                </div>

                {Link && !hiddenLink && !isAssessment && <div className={classes.LinkWrapper}>
                    {/* <LinkIcon /> */}
                    <NavigateLink link={Link}>
                        <div className={classes.Link}>{Link}</div>
                    </NavigateLink>
                    <CopyToCliboard text={`${window.config.baseApiUrl}/delay-navigate?link=${Link}/1`} />
                </div>}

                {ProviderLogo && <div className={classes.ProviderLogoWrapper}>
                    {/* <Sharp /> */}
                    <div className={classes.ProviderLogo} style={{ backgroundImage: `url(${ProviderLogo})` }} />
                </div>}

                {Link && !hiddenLink && <div className={classes.EnterBtn}>
                    <NavigateLink link={Link}>
                        <FillBGBtn backgroundColor={"#53C8E1"} small dropClass={classes.DropBtn} color={isAssessment ? "black" : "white"} isBtn={false}>{texts.enter}</FillBGBtn>
                    </NavigateLink>
                </div>}

            </div>
        </div >
    </AccessibilityPopup>
}

export default CalendarEventPopup